import React, { useEffect, useRef, useState } from "react"
import './AgeVerification.scss'
import { config } from '../../config/config';
import { handleAnalyticsBot, isMobileOS } from '../util/commonUtil'

type AgeVerification = {
  setShowVerifyAge: (type: boolean) => void,
  endScreenMountingStyle: string,
  setisOverlayScreenMounted: (type: boolean) => void,
  showVerifyAge: boolean,
}

const AgeVerification = ({setShowVerifyAge, endScreenMountingStyle, showVerifyAge, setisOverlayScreenMounted}:AgeVerification) => {

  const verifyAge = useRef<HTMLDivElement>(null);
  let timoutIdShowVerifyAge: ReturnType<typeof setTimeout> | null = null;


  const closeAgeVerificationPage = () => {
    timoutIdShowVerifyAge = setTimeout(() => {
      setShowVerifyAge(false)
    }, 500);
    setisOverlayScreenMounted(false)
  }

  const onclickHandler = () => {
    handleAnalyticsBot(`${isMobileOS() ? 'app' : 'web'}:chatbot:nsw id verification:verify my age`, 'chatbot nsw id verification', 'chatbotTriggerAdobeAnalytics');
    window.open(`${config.BWS_MY_ACCOUNT_URL}?i_cid=chatbot-nsw-id-verification`, '_blank');
  }

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    
    window.onclick = (event:Event) => {
        const { className } = event.target as HTMLElement;
        if ( verifyAge.current && !verifyAge.current.contains(event.target as HTMLElement) && className && className.indexOf('header') && className.indexOf('brand') ) {
            timeoutId =  setTimeout(() => {
              closeAgeVerificationPage();
            }, 450);
        }
    }
    
    return () => {
        if(timeoutId) { clearTimeout(timeoutId);}
        if(timoutIdShowVerifyAge) { clearTimeout(timoutIdShowVerifyAge);}
    }
}, [showVerifyAge])

  return (
    <div className={"widget__overlay--endsession verify-Age" + endScreenMountingStyle} ref={verifyAge}>
      <div className="verify-Age-text">
        <h2>Online age check required for same-day deliveries in NSW from June 1</h2>
      </div>
      
        <div className="verify-Age-ID-documents">
          <div>
            <img src="/images/icon-filled-dark-circle.svg" alt="" />
            <span>This is only mandatory for same-day deliveries in NSW after June 1.</span>
          </div>
          <div>
            <img src="/images/icon-filled-dark-circle.svg" alt="" />
            <span>Verify your ID now will save you time at checkout in the future. If you're a BWS member you'll only have to complete this once.</span>
          </div>
          <div>
            <img src="/images/icon-filled-dark-circle.svg" alt="" />
            <span>Simply go to your account & follow the prompt in 'My Details' section.</span>
          </div>

        </div>
        
      <div className="verify-Age-buttons">
        <button className="verify-Age-buttons-cancel" onClick={closeAgeVerificationPage}>Cancel</button>
        <button className="verify-Age-buttons-verify" onClick={onclickHandler}>Verify my age <img src="/images/Vector-outbound-link.svg" alt="" /></button>
      </div>
      </div>
  )
}

export default AgeVerification